<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.id"
                          :label="labels.id"
                          :error-messages="errors.collect('filters.id')"
                          data-vv-name="filters.id"
                          :data-vv-as="labels.id"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.reportName"
                          :label="labels.reportName"
                          :error-messages="errors.collect('reportName')"
                          data-vv-name="reportName"
                          :data-vv-as="labels.reportName"
                          data-vv-scope="filters"
                          v-validate="'max:100'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-autocomplete
                          :items="rptStatuses"
                          v-model="filters.statusDesc"
                          :label="labels.statusDesc"
                          item-text="label"
                          item-value="value"
                          data-vv-name="statusDesc"
                          :data-vv-as="labels.statusDesc"
                          :error-messages="errors.collect('filters.statusDesc')"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.usrId"
                          :label="labels.usrId"
                          :error-messages="errors.collect('usrId')"
                          data-vv-name="usrId"
                          :data-vv-as="labels.usrId"
                          data-vv-scope="filters"
                          v-validate="'max:100'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <cal-picker
                          v-model="filters.processDT"
                          :label="labels.processDT"
                          :data-vv-as="labels.processDT"
                          data-vv-name="processDT"
                        ></cal-picker>
                      </v-flex>
                      <v-flex md4 xs12>
                        <cal-picker
                          v-model="filters.processEndDT"
                          :label="labels.processEndDT"
                          :data-vv-as="labels.processEndDT"
                          data-vv-name="processEndDT"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-flex xs12>
        <v-flex xs12 class="mt-1">
          <message :messages="messages"></message>
        </v-flex>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :loading="loading"
            :server-items-length="totalItems"
            :custom-filter="customSearch"
            :no-data-text="noDataText"
            v-bind:options.sync="pagination"
          >
            <template v-slot:item="row">
              <tr>
                <td class="text-xs-left">{{ row.item.id }}</td>
                <td class="text-xs-left">{{ row.item.customName }}</td>
                <td class="text-xs-left">{{ row.item.processDT ? formatDisplayDateTime(row.item.processDT) : '-' }}</td>
                <td class="text-xs-left">{{ row.item.processEndDT ? formatDisplayDateTime(row.item.processEndDT) : '-' }}</td>
                <td class="text-xs-left">{{ row.item.createdBy }}</td>
                <td class="text-xs-left">{{ row.item.fileFormat }}</td>
                <td class="text-xs-left">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" :color="row.item.color">{{ row.item.icon }}</v-icon>
                    </template>
                    <span>{{ row.item.statusDesc }}</span>
                  </v-tooltip>
                </td>
                <td class="table-action-header">
                  <table-action
                    :error="showError(row.item.init)"
                    @error="showErrorDialog(row.item)"
                    :report_param="true"
                    @report_param="doReportParam(row.item)"
                    :download="canDownload(row.item.init)"
                    @download="doDownload(row.item)"
                    :retry="canRetry(row.item.init)"
                    @retry="doRetry(row.item)"
                  ></table-action>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
    <v-dialog v-model="errorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="selectedJob" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li>
                {{ selectedJob.errorMsg }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="errorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showReportParam" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>Report Run Time Parameters</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text v-if="selectedJob">
          <pre class="wrap-pre">{{ selectedJob.rptKeys }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showReportParam = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>
<script>
import { extractMenu } from '@/utils/extract'
import { formatDisplayDate2, formatDisplayDateTime, formatDisplayDateTime2, removeTime } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatProcess } from '@/utils/report'
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { downloadPrompt } from '@/utils/file'
import * as TableConst from '@/mixins/table'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      jobs: [],
      menu: {},
      selectedJob: undefined,
      errorDialog: false,
      totalItems: 0,
      headers: [
        { text: 'Job Id', value: 'id' },
        { text: 'Report Name', value: 'customName' },
        { text: 'Requested Date', value: 'processDT' },
        { text: 'Completed Date', value: 'processEndDT' },
        { text: 'Created By', value: 'createdBy' },
        { text: 'File Format ', value: 'fileFormat' },
        { text: 'Status ', value: 'statusCode' },
        TableConst.tableActionHeader
      ],
      labels: {
        id: 'Job ID',
        reportName: 'Report Name',
        statusDesc: 'Report Status',
        usrId: 'Created By',
        processDT: 'Requested Date',
        processEndDT: 'Completed Date'
      },
      filters: {
        id: null,
        reportName: null,
        statusDesc: null,
        usrId: null,
        processDT: null,
        processEndDT: null
      },
      rptStatuses: [
        { label: 'Complete', value: 'C' },
        { label: 'New', value: 'N' },
        { label: 'Fail to Process', value: 'FP' },
        { label: 'Fail to Generate', value: 'F' },
        { label: 'Processing', value: 'P' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      },
      showReportParam: false
    }
  },
  methods: {
    async doFetchReport(options) {
      const apiURI = this.$store.state.app.menu.rptJobsHistory
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage === -1 ? this.totalItems : itemsPerPage,
            options: options
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.processDT !== null && massageFilters.processDT !== '') {
            massageFilters.processDT = formatDisplayDateTime2(removeTime(massageFilters.processDT))
          }
          if (massageFilters.processEndDT !== null && massageFilters.processEndDT !== '') {
            massageFilters.processEndDT = formatDisplayDateTime2(removeTime(massageFilters.processEndDT))
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            const { data } = result
            this.items = []
            if (data) {
              this.totalItems = result.data.totalElements
              this.menu = extractMenu(data._links)
              if (data.data && data.data.length > 0) {
                data.data.map((job) => {
                  // Follow mutation on rptProcess
                  formatProcess(job, job.statusCode)
                })
              }
              this.$set(this, 'items', data.data)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    getReportFormat(format) {
      format = format.toUpperCase()
      const result = reportFormat[format]
      if (result) {
        return result
      } else {
        return {
          icon: 'mdi-file-document',
          color: 'blue'
        }
      }
    },
    formatDisplayDate(myDate) {
      return formatDisplayDate2(myDate)
    },
    formatDisplayDateTime(myDate) {
      return formatDisplayDateTime(myDate)
    },
    async doDownload(job) {
      this.selectedJob = job
      if (this.selectedJob && this.selectedJob.init === 1) {
        const apiURI = this.$store.state.app.menu.rptDownload
        if (apiURI) {
          try {
            const expand = {
              id: this.selectedJob.id
            }
            this.selectedJob.downloading = true

            const result = await this.$http.get(expandURI(apiURI, expand), {
              responseType: 'blob'
            })
            var headers = result.headers
            var blob = new Blob([result.data], { type: headers['content-type'] })
            var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
            downloadPrompt(blob, filename)

            this.selectedJob.downloading = false
            this.$store.dispatch('getReportsCount')
            this.doFetchReport()
          } catch (err) {
            const { data } = err.response
            if (data) {
              // As the request is requesting blob, error has to be formatted back to json
              try {
                const errUrl = URL.createObjectURL(data)
                const errRes = await this.$http.get(errUrl)
                URL.revokeObjectURL(errUrl)
                if (errRes.data) {
                  this.notify(errRes.data)
                }
              } catch (err2) {
                const { data } = err.response
                if (data) {
                  this.notify(data)
                }
              }
            }
            this.selectedJob.downloading = false
          }
        } else {
          this.notify('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    showError(value) {
      return value === 2
    },
    canDownload(value) {
      return value === 1
    },
    canRetry(value) {
      return value === 2
    },
    doReportParam(job) {
      this.selectedJob = job
      this.showReportParam = true
    },
    async doRetry(job) {
      this.selectedJob = job
      if (this.selectedJob && this.selectedJob.init === 2) {
        const apiURI = this.$store.state.app.menu.rptReprocess
        if (apiURI) {
          try {
            const expand = {
              id: this.selectedJob.id
            }
            const result = await this.$http.post(expandURI(apiURI, expand))
            const { data } = result
            if (data.data) {
              formatProcess(data.data, data.data.statusCode)
              const index = this.items.indexOf(this.items.find((job) => job.id === this.selectedJob.id))

              // has to use this.$set as data in obj or arr has no reactivity
              this.$set(this.items, index, data.data)
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        } else {
          this.notify('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    showErrorDialog(job) {
      this.selectedJob = job
      this.errorDialog = true
    },
    doFilters() {
      this.$validator.validateAll('filters').then((result) => {
        if (result) {
          this.doFetchReport(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.id = null
      this.filters.reportName = null
      this.filters.statusDesc = null
      this.filters.usrId = null
      this.filters.dateCreatedFrom = null
      this.filters.dateCreatedTo = null
      this.filters.processDT = null
      this.filters.processEndDT = null
      this.doFetchReport(false)
    }
  },
  watch: {
    'pagination': function (value) {
      this.doFetchReport(false)
    },
    '$store.state.user.notification.rptId': function (value) {
      if (value) {
        this.doFetchReport(false)
      }
    },
    '$store.state.user.notification.rptStatus': function (value) {
      if (value) {
        this.doFetchReport(false)
      }
    }
  },
  mounted() {
    // this.doFetchReport()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
.not-download {
  font-weight: bold;
  background-color: rgb(240, 240, 240);
}
.wrap-pre {
  white-space: pre-wrap;   /* preserves line breaks but wraps long lines */
  word-wrap: break-word;   /* breaks long words if necessary */
}
</style>
